export function fileGQLFields() {
    return `
    extension
    id
    name
    size
    url
    downloadUrl
  `;
}
